/**
 * Initializes the PCM audio player worklet that streams inline PCM chunks
 * coming from the ADK websocket events.
 */
export async function startAudioPlayerWorklet() {
  if (typeof window === 'undefined') {
    throw new Error('Audio player can only be initialized in the browser');
  }

  const audioContext = new AudioContext({
    sampleRate: 24000,
  });

  // For webpack/vite, we need to use a different approach
  // We'll inline the worklet code or use a blob URL
  const workletCode = `
    class PCMPlayerProcessor extends AudioWorkletProcessor {
      constructor() {
        super();
        this.bufferSize = 24000 * 180;
        this.buffer = new Float32Array(this.bufferSize);
        this.writeIndex = 0;
        this.readIndex = 0;
        this.port.onmessage = (event) => {
          if (event.data?.command === 'endOfAudio') {
            this.readIndex = this.writeIndex;
            return;
          }
          const int16Samples = new Int16Array(event.data);
          this.enqueue(int16Samples);
        };
      }

      enqueue(samples) {
        for (let i = 0; i < samples.length; i += 1) {
          const floatVal = samples[i] / 32768;
          this.buffer[this.writeIndex] = floatVal;
          this.writeIndex = (this.writeIndex + 1) % this.bufferSize;
          if (this.writeIndex === this.readIndex) {
            this.readIndex = (this.readIndex + 1) % this.bufferSize;
          }
        }
      }

      process(inputs, outputs) {
        const output = outputs[0];
        const framesPerBlock = output[0].length;
        for (let frame = 0; frame < framesPerBlock; frame += 1) {
          output[0][frame] = this.buffer[this.readIndex];
          if (output.length > 1) {
            output[1][frame] = this.buffer[this.readIndex];
          }
          if (this.readIndex !== this.writeIndex) {
            this.readIndex = (this.readIndex + 1) % this.bufferSize;
          }
        }
        return true;
      }
    }

    registerProcessor('pcm-player-processor', PCMPlayerProcessor);
  `;

  const blob = new Blob([workletCode], { type: 'application/javascript' });
  const workletUrl = URL.createObjectURL(blob);

  await audioContext.audioWorklet.addModule(workletUrl);

  const audioPlayerNode = new AudioWorkletNode(
    audioContext,
    'pcm-player-processor'
  );

  audioPlayerNode.connect(audioContext.destination);

  URL.revokeObjectURL(workletUrl);

  return [audioPlayerNode, audioContext];
}


